/**
 * ****************************************************************************
 * @description     :   Main file of application
 * @created at      :   2022/07/13
 * @created by      :   
 * @package         :   dailyreportsystem
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * import libraries
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
// import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

/**
 * import store and report
 */
import initStore from './redux/store';
import reportWebVitals from './reportWebVitals';

/**
 * import styles
 */
import './assets/scss/theme.scss';
import './assets/scss/dashlite.scss';

/**
 * import child components
 */
import App from './App';


/**
 * create store for redux
 */
const store = initStore();

/**
  * Render application to file index to show in browser
  */
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);
 
/**
  * If you want to start measuring performance in your app, pass a function
  * to log results (for example: reportWebVitals(console.log))
  * or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  */
if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    reportWebVitals(console.log);
}
